import { fabricObjectExtend } from '../DrawingUtil.js';

class Shape {
    constructor(props) {
        this.drawingCanvas = props.drawingCanvas;
        this.onDrawCompleted = props.onDrawCompleted;
    }
    draw(fabricItem) {
        this.toFebricObject(fabricItem);
        this.drawingCanvas.add(fabricItem);
        this.drawingCanvas.renderAll();
        return fabricItem;
    }

    toFebricObject(shape) {
        shape.toObject = (function (toObject) {
            return function () {
                return fabric.util.object.extend(toObject.call(this), {
                    uuid: this.uuid,
                    uuid_parent: this.uuid_parent,
                });
            };
        })(shape.toObject);
    }
    // get drawingCanvas() {
    //     return this.drawingCanvas;
    // }
    toString() {
        return Object.getPrototypeOf(this).constructor.name;
    }
}

export { Shape };
